import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FieldItem } from '../FieldItem';
import { Duration, DurationInput } from './DurationInput';

export const DURATION_INVALID_TEXT = '종료일은 시작일보다 빠르게 설정할 수 없습니다.';

export function DurationInputField({
  name = 'duration',
  onValue,
}: {
  name?: string,
  onValue?: (value: Duration) => void,
}) {
  const { control, formState, trigger, getValues } = useFormContext();
  const errorInfo = formState.errors?.[name];

  useEffect(() => {
    const value = getValues(name);
    if (value) {
      trigger();
    }
  }, []);

  return (
    <FieldItem error hint={errorInfo?.message as string} hintAlign="end">
      <Controller
        control={control}
        name={name}
        rules={{
          validate: (value) => {
            const { startAt, endAt } = value;

            return startAt && endAt && startAt > endAt
              ? DURATION_INVALID_TEXT
              : true;
          },
        }}
        render={({ field }) => (
          <DurationInput
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
              onValue?.(value);
              trigger(name);
            }}
          />
        )}
      />
    </FieldItem>
  );
}
